import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type FanTokenUnavailableMarketDrawerProps = {
	closeModal: () => void;
	testID: string;
};

export const FanTokenUnavailableMarketDrawer = ({ closeModal, testID }: FanTokenUnavailableMarketDrawerProps) => {
	const { $t } = useIntl();

	const fanTokenUnavailableMarketDrawerData = {
		buttonText: $t('wallet.withdraw.fanTokenUnavailableMarketDrawer.buttonText'),
		image: GoatAwkward,
		testID: testID,
		title: $t('wallet.withdraw.fanTokenUnavailableMarketDrawer.title')
	};

	return <GenericDrawer {...fanTokenUnavailableMarketDrawerData} onButtonPress={closeModal} />;
};
